import React from "react";
import general from "../../../../../../general";
import CustomCardBase from "./CustomCardBase";

// subType=5 社区活动
export default function CommunityActivityMessage({ msg }) {
  const { attach } = msg;
  return (
    <CustomCardBase
      tagColor="#6167E0"
      tagText="活动"
      title={attach?.title}
      gameInfo={attach?.game_info}
      desc={attach?.content}
      descClass="imc-line2"
      onClick={() => {
        general.game = attach?.game_info;
        general.history.push(
          "communityDetail?id=" + attach?.id +
          "&tagid=" + attach?.tagid +
          "&circles_type=" + attach?.circles_type +
          "&topic_id=" + attach?.topic_id
        );
      }}
    />
  );
}
